'use client';

import { faSearch } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@pickleballinc/ui/components/ui/button';
import clsx from 'clsx';
import { useRouter, useSearchParams } from 'next/navigation';
import { DebounceInput } from 'react-debounce-input';

import { teamLeagueTypeMap, TeamLeagueTypes } from '@/utils/types';

interface LeaguesPastFutureFilterProps {
	hasData: boolean;
}
export const LeaguesPastFutureFilter = ({ hasData }: LeaguesPastFutureFilterProps) => {
	const router = useRouter();
	const searchParams = useSearchParams();
	const activeButton = searchParams?.get('status') ?? 'active';
	const search = searchParams?.get('search') || '';
	const typeForTeamLeague = searchParams?.get('team_league_type') || 'registeredfor';
	const currentTeamLeagueType = teamLeagueTypeMap[typeForTeamLeague];
	const isFavorites = currentTeamLeagueType === TeamLeagueTypes.Favorites;

	const showCurrentPastFilters = !isFavorites;

	const handlePageChange = (status: 'active' | 'past') => {
		const newSearchParams = new URLSearchParams(searchParams || '');
		newSearchParams.set('status', status);
		router.replace(`?${newSearchParams.toString()}`);
	};

	const updateSearchParams = (updates: Record<string, string>) => {
		const newParams = new URLSearchParams(searchParams.toString());
		Object.entries(updates).forEach(([key, value]) => {
			newParams.set(key, value);
		});
		router.replace(`?${newParams.toString()}`, {
			scroll: false
		});
	};

	const showSearchInput = hasData || search ? true : false;

	return (
		<div className="mt-4 flex gap-4 items-center">
			{showCurrentPastFilters ? (
				<div className="flex gap-3">
					<Button
						onClick={() => handlePageChange('active')}
						className={clsx(
							'border transition-colors duration-150',
							activeButton !== 'past'
								? 'border-darkorange-600 bg-darkorange-100 text-darkorange-600 hover:bg-darkorange-100 hover:text-darkorange-600'
								: 'border-gray-300 bg-transparent text-gray-900 hover:bg-transparent hover:text-gray-900'
						)}
					>
						Active
					</Button>

					<Button
						onClick={() => handlePageChange('past')}
						className={clsx(
							'border transition-colors duration-150',
							activeButton === 'past'
								? 'border-darkorange-600 bg-darkorange-100 text-darkorange-600 hover:bg-darkorange-100 hover:text-darkorange-600'
								: 'border-gray-300 bg-transparent text-gray-900 hover:bg-transparent hover:text-gray-900'
						)}
					>
						Past
					</Button>
				</div>
			) : null}

			{showSearchInput ? (
				<div className="relative w-full sm:w-[220px] mr-auto">
					<FontAwesomeIcon icon={faSearch} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-500" size="sm" />

					<DebounceInput
						type="text"
						className="w-full rounded-md border text-sm border-gray-300 bg-white pl-9 pr-3 py-1.5 text-gray-700 placeholder-gray-500 focus:border-gray-200 focus:outline-none focus:ring-2 focus:ring-gray-100"
						placeholder="Search for league"
						minLength={2}
						debounceTimeout={500}
						value={search}
						onChange={(e) => updateSearchParams({ search: e.target.value })}
						maxLength={100}
					/>
				</div>
			) : null}
		</div>
	);
};
